import { BarLoader as ReactBarLoader } from "react-spinners";
import { cn } from "@/lib/utils";

type BarLoaderSize = "sm" | "md" | "lg";

interface BarLoaderProps {
  size?: BarLoaderSize;
  color?: string;
  className?: string;
}

const sizeMap: Record<BarLoaderSize, { width: number; height: number }> = {
  sm: { width: 120, height: 4 },
  md: { width: 200, height: 6 },
  lg: { width: 280, height: 6 },
};

export function BarLoader({ size = "sm", color, className }: BarLoaderProps) {
  const { width, height } = sizeMap[size];

  return (
    <div className={cn(className)}>
      <ReactBarLoader width={width} height={height} color={color} />
    </div>
  );
}

export default BarLoader;
